import { render, staticRenderFns } from "./checkout-price.vue?vue&type=template&id=50ca60ef&scoped=true&"
import script from "./checkout-price.vue?vue&type=script&lang=js&"
export * from "./checkout-price.vue?vue&type=script&lang=js&"
import style0 from "./checkout-price.vue?vue&type=style&index=0&id=50ca60ef&lang=scss&scoped=true&"
import style1 from "./checkout-price.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ca60ef",
  null
  
)

export default component.exports